import React from 'react';
import TableRow from './TableRow';
import ExpandableTableRow from './ExpandableTableRow';
import { TableRowData } from '../utils/tableData';

interface TableRendererProps {
  tableData: TableRowData[];
  expandedRows: number[];
  toggleRow: (index: number) => void;
}

const TableRenderer: React.FC<TableRendererProps> = React.memo(({
  tableData,
  expandedRows,
  toggleRow
}) => {
  return (
    <>
      {tableData.map((rowData, index) => {
        const key = `row-${index}`;
        
        if (rowData.type === 'expandable' && rowData.subItems) {
          return (
            <ExpandableTableRow
              key={key}
              label={rowData.label}
              amount={rowData.amount}
              actionCell={rowData.actionCell}
              subItems={rowData.subItems}
              isExpanded={expandedRows.includes(index)}
              onToggle={() => toggleRow(index)}
              rowId={`row-${index}`}
              className={rowData.className}
              style={rowData.style}
              amountCellStyle={rowData.amountCellStyle}
            />
          );
        }

        return (
          <TableRow
            key={key}
            label={rowData.label}
            amount={rowData.amount}
            actionCell={rowData.actionCell}
            className={rowData.className}
            style={rowData.style}
          />
        );
      })}
    </>
  );
});

TableRenderer.displayName = 'TableRenderer';

export default TableRenderer;